/**
 * created by li si yi
 * 线索待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import NewMediaManage from "../../../../newMediaMatrix/pms/newMediaManagement/NewMediaManage";
import BaseComponent, {contentParser} from "../../../../../base/BaseComponent";
import {message} from "../../../../sysManagement/utils/sysManagementUtils";
import DetailsModal from "../../../../sysManagement/selectedTopicManagement/components/detailsModal";

class BusNewsClue extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        this.data = data;
        // console.log('媒体备案申请*------', data);
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "busNewsClue") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'BusNewsClueIcon';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        this.details.show(data?.data?.id, {});
        this.call=call;
        // this.newMediaManage && this.newMediaManage.getById(data.data, (res) => {
        //     if (res === false) {
        //         message.error('数据已删除!');
        //     } else {
        //         call && call();
        //     }
        // });
    };

    call=null;

    render() {
        return (
            <div style={{display: 'none'}}>
                {this.detailsModal()}
            </div>
        )
    }
    //详情页面弹窗
    detailsModal=()=>{
        let sysConfigData={};
        try {
            let newsclue = this.sysConfigGetValueByKey("newsclue",'{}');
            sysConfigData=JSON.parse(newsclue);
            contentParser(sysConfigData,sysConfigData);
        } catch (e) {
            console.log(e.toString())
        }
        // let sysConfigData = this.sysConfig;
        let props={
            title:"新增"+sysConfigData.title,
            details:sysConfigData.detailTitle || sysConfigData.title+"详情",
            sysConfigData:sysConfigData,
            detailsData:this.state.detailsData || {},
            pojoName: sysConfigData.pojoName, // 后端存储数据的表名
            activitiConfName: sysConfigData.activitiConfName, // 流程图识别码
        };
        return JSON.stringify(sysConfigData) === "{}" ? <></> : (
            <DetailsModal {...props} ref={(details)=>{this.details=details}} callBack={()=>{
                this.call && this.call();
            }}/>
        )
    };
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(BusNewsClue)